function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { useStyle } from "./VisuallyHiddenElement.styles";
var VisuallyHiddenElement = function(_param) {
    var tmp = _param.as, elem = tmp === void 0 ? 'span' : tmp, children = _param.children, _showOnFocus = _param.showOnFocus, showOnFocus = _showOnFocus === void 0 ? false : _showOnFocus, testID = _param.testID, propDrop = _objectWithoutProperties(_param, [
        "as",
        "children",
        "showOnFocus",
        "testID"
    ]);
    var elementStyle = useStyle(showOnFocus).elementStyle;
    var HiddenElement = elem;
    return _jsx(HiddenElement, _objectSpread({}, injectTestId(testID), {
        css: elementStyle
    }, propDrop, {
        children: children
    }));
};
export { VisuallyHiddenElement };
export default VisuallyHiddenElement;
